const countryCodes = Object.freeze(['gb', 'gg', 'im', 'je']);

function isCrownDependency(countryCode) {
    return countryCodes.indexOf(countryCode) >= 0;
}

export { countryCodes, isCrownDependency };
